// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "238" ? "lpu-staff" : chunkId) + "/" + (chunkId === "238" ? "lpu-staff" : chunkId) + "." + {"119": "2ff3282bb12e8515","123": "5d3112dca2e0e667","238": "ae07ddef098c73b1","29": "050058b9d06cb7f8","85": "0ce93661cd87743c","97": "c6b368026493631f",}[chunkId] + ".css"
}